import { render } from "./BookingsLayout.vue?vue&type=template&id=0d1c4f80&scoped=true"
import script from "./BookingsLayout.vue?vue&type=script&lang=js"
export * from "./BookingsLayout.vue?vue&type=script&lang=js"

import "./BookingsLayout.vue?vue&type=style&index=0&id=0d1c4f80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1c4f80"]])

export default __exports__